export const URL_PATHS = {
  // bank
  GET_LIST_BANK: "/payment/bank/getAll",
  CREATE_NEW_BANK: "/payment/bank/synchronizeBank",
  //channel
  ADD_PAYMENT_CHANNEL: "/payment/channel/addPaymentChannel",
  GET_LISt_CHANNEL_BY_CLIENT_ID: "/payment/channel/getAllChannel",
  //login-register
  LOGIN: "/identity/auth/token",
  REGISTER: "/identity/users/create_user",
  REFRESH_TOKEN: "/identity/auth/refresh",
  INTROSPECT_TOKEN: "/identity/auth/introspect",
  LOGOUT: "/identity/auth/logout",
  //transaction
  GET_LIST_TRANSACTION: "/payment/transaction/getAllTransaction",
  REFUND: "/payment/auth/refundWithToken",
};
